<!-- vertical-layout -->
@if (coreConfig.layout.type === 'vertical') {
  <vertical-layout></vertical-layout>
}
<!-- / vertical-layout -->

<!-- horizontal-layout -->
@if (coreConfig.layout.type === 'horizontal') {
  <horizontal-layout></horizontal-layout>
}
<!-- / horizontal-layout -->

<!-- theme customizer -->
@if (coreConfig.layout.customizer) {
  <core-sidebar
    name="themeCustomizer"
    class="customizer d-none d-md-block"
    [invisibleOverlay]="true"
    >
    <a
      class="customizer-toggle d-flex align-items-center justify-content-center"
      (click)="toggleSidebar('themeCustomizer')"
      >
      <span [data-feather]="'settings'" [class]="'spinner'"></span>
    </a>
    <core-theme-customizer></core-theme-customizer>
  </core-sidebar>
}
<!-- / theme customizer -->
